import Cookies from '../../node_modules/js-cookie/dist/js.cookie.js'

export const get = (...args) => Cookies.get(...args)
export const set = (...args) => Cookies.set(...args)
export const remove = (...args) => Cookies.remove(...args)
export const withAttributes = (...args) => Cookies.withAttributes(...args)
export const withConverter = (...args) => Cookies.withConverter(...args)

export default Cookies
